import { cmykToRGB } from "client/services/Color/utils/cmykToRGB";
import { getSelectedColorInfo } from "client/services/Color/utils/getSelectedColorInfo";
import { setSelectedColor } from "store/features/colorPicker/actions";
import { CMYK, ColorFormat, colorComponents, isCMYK } from "store/features/colorPicker/types";
import { useAppDispatch } from "store/store";
import tinycolor, { ColorInputWithoutInstance } from "tinycolor2";

export const useColorComponent = <C extends Exclude<ColorInputWithoutInstance, string> | CMYK, CF extends ColorFormat>(
    color: C,
    format: CF,
) => {
    const dispatch = useAppDispatch();
    const components = colorComponents[format];
    const handleChange = (value: number, key: keyof typeof color) => {
        let tiny: tinycolor.Instance;
        if (isCMYK(color)) {
            const { c, m, y, k, a } = {
                c: key === "c" ? value : color.c,
                m: key === "m" ? value : color.m,
                y: key === "y" ? value : color.y,
                k: key === "k" ? value : color.k,
                a: key === "a" ? value : color.a,
            };
            const rgb = cmykToRGB(c, m, y, k, a);
            tiny = tinycolor(rgb);
        } else {
            if (key === "a") value /= 100;
            tiny = tinycolor({
                ...color,
                [key]: value,
            });
        }
        const { h, s, l } = tiny.toHsl();
        const colorInputChangeEvent = new CustomEvent("color_input_change", { detail: { h, s, l } });
        document.body.dispatchEvent(colorInputChangeEvent);
        const newRGB = tiny.toRgb();
        dispatch(setSelectedColor(getSelectedColorInfo(newRGB.r, newRGB.g, newRGB.b, newRGB.a)));
    };
    return { color, components, handleChange };
};
